import Spinner from "react-bootstrap/Spinner";

function SimpleSpinner({ myClassName = "Icon50", isFullPage = false }) {
  if (isFullPage) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100%" }}
      >
        <Spinner animation="border" className={`custom-spinner ${myClassName}`} />
      </div>
    );
  }

  return (
    <div className="d_grid justify-content-center align-items-center mx-auto my-0 mh-100">
      <Spinner animation="border" className={`custom-spinner ${myClassName}`} />
    </div>
  );
}

export default SimpleSpinner;